var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('div',{staticClass:"loading"},[_c('div',{staticClass:"loadingDiv",style:(_vm.position)},[_c('img',{staticClass:"logo",attrs:{"src":"https://resource.rcclchina.com.cn/logo/PC/logoLoadingPc.gif","alt":""}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }